import React from "react";
import s from "./NumberManagement.module.scss";
import { NavLink } from "react-router-dom";
import ArrowRight from "../../../../global components/Icons/ArrowRight";
import TableWrapper from "./local components/TableWrapper";

function NumberManagement() {
  return (
    <>
      <div className={s.wrapper}>
        <div className={s.header}>
          <div className={s.titles}>
            <h2 className={s.title}>Number management</h2>
            <p className={s.subtitle}>Manage all users number assignment</p>
          </div>
          <NavLink to={"pending-requests"} className={s.pendingRequestLink}>
            Number request
            <ArrowRight className={s.icon} />
          </NavLink>
        </div>
        {/* <div className={s.searchInput} onClick={() => setOpen(true)}>
          <SearchInput
            style={{ width: "100%", height: "100%" }}
            placeholder="Search Twilio for available numbers"
            width={332}
            height={45}
            handleSearch={() => {}}
            className={s.input}
          />
        </div> */}
        <TableWrapper />
      </div>

    </>
  );
}

export default NumberManagement;
